import type { Person } from '../types/people';

/** Prefer API avatar_url; fallback to local /avatars/<id>.png if you add files in public/avatars. */
export function getPersonAvatarUrl(person: Person): string {
  if (person.avatar_url?.trim()) return person.avatar_url.trim();
  return `/avatars/${person.id}.png`;
}

/** Initials from name (e.g. "Jane Doe" -> "JD"). */
export function getPersonInitials(person: Person): string {
  return person.name
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || '?';
}

